module.exports = __webpack_public_path__ + "static/media/North grove 5.060934cf.jpg";